module.exports = __webpack_public_path__ + "./images/map_pointer_icon.341f2b.svg";